var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92378 1.84001L9.09711 4.18668C9.25711 4.51334 9.68378 4.82668 10.0438 4.88668L12.1704 5.24001C13.5304 5.46668 13.8504 6.45334 12.8704 7.42668L11.2171 9.08001C10.9371 9.36001 10.7838 9.90001 10.8704 10.2867L11.3438 12.3333C11.7171 13.9533 10.8571 14.58 9.42378 13.7333L7.43045 12.5533C7.07045 12.34 6.47711 12.34 6.11045 12.5533L4.11711 13.7333C2.69045 14.58 1.82378 13.9467 2.19711 12.3333L2.67045 10.2867C2.75711 9.90001 2.60378 9.36001 2.32378 9.08001L0.670447 7.42668C-0.302886 6.45334 0.0104473 5.46668 1.37045 5.24001L3.49711 4.88668C3.85045 4.82668 4.27711 4.51334 4.43711 4.18668L5.61045 1.84001C6.25045 0.566676 7.29045 0.566676 7.92378 1.84001Z",
    fill: "#FFC130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c4abc7e03bbc4fb98e7924d894db1ee6.svg";
export { ForwardRef as ReactComponent };